import { gql } from '@apollo/client';

export const LINK_STAFF_TO_PATIENT = gql`
  mutation linkUserToPatient($data: PatientUserIdsInput!) {
    linkUserToPatient(data: $data)
  }
`;
